import { createBrowserHistory } from 'history';
export const history = createBrowserHistory();
export const locationReload = window.__cy_stub_location_reload || (() => window.location.reload());

export const getQueryParams = () => {
  const params = new URLSearchParams(window.location.search);
  let paramObj = {};
  // eslint-disable-next-line no-unused-vars
  for (let key of params.keys()) {
    paramObj[key] = decodeURI(params.get(key));
  }

  return paramObj;
};
